<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <!-- <abc :abcvalue="myvalue" @ondo="ondoHandler" ref="abc"></abc> -->
      <!-- {{ this.myvalue }} -->
      <agentVendorShop @select="selectHandler" />
      <div>
        <el-form-item label="机器ID">
          <el-input
            v-model="formInline.machineid"
            placeholder="请输入机器ID"
          ></el-input>
        </el-form-item>

        <el-form-item label="IMEI">
          <el-input
            v-model="formInline.machineImei"
            placeholder="请输入机器IMEI"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-form>
      <el-form-item style="margin-left:1.5rem;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        prop="machineid"
        label="机器id"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="machineImei"
        label="IMEI"
        width="150"
      ></el-table-column>

      <el-table-column
        prop="machineName"
        label="名称"
        width="190"
      ></el-table-column>
      <el-table-column label="加盟商" width="155">
        <template slot-scope="scope">
          <div>{{ $getVendorName(scope.row.vendorid) }}</div>
          <div>{{ scope.row.vendorid }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="machineCity" label="城市"></el-table-column> -->
      <el-table-column label="所属门店">
        <template slot-scope="scope">
          <div>{{ $getShopName(scope.row.machineInShopid) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <div>{{ scope.row.machineStatusName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
// import abc from "@/components/layout/abc";
import agentVendorShop from "@/components/layout/agentVendorShop";
import enumObject from "../../plugins/enum";
// import moment from "moment";

export default {
  components: {
    // abc,
    agentVendorShop
  },
  data() {
    return {
      formInline: {
        machineid: "",
        machineImei: "",
        agentid: "",
        vendorid: "",
        machineInShopid: ""
      },
      tableData: [],
      CITY_ENUM: enumObject.CITY_ENUM,
      //MACHINE_STATUS_ENUM: enumObject.MACHINE_STATUS_ENUM,
      //vendorsList: [],
      machineEnableList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ],
      //multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // isCreated: false,
      // isEdit: false,
      // isPrint: false,
      // isControl: false,
      // machineInfo: null,
      // imageIDs: [],
      // shopInfoEntityList: [],
      // vendorEntityList: [],
      machineModelList: [],
      //vendorList: [],
      //shopList: [],
      //agentList: []
      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: []
    };
  },

  async mounted() {
    if (this.$route.query.shopid) {
      //await this.getShops({ shopid: this.$route.query.shopid });
      this.formInline.machineInShopid = this.$route.query.shopid;
    }
    if (this.$route.query.machineEnable != undefined) {
      this.formInline.machineEnable = this.$route.query.machineEnable;
    }
    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }
    if (this.$route.query.imei) {
      this.formInline.machineImei = this.$route.query.imei;
    }
    if (this.$route.query.machineStatus != undefined) {
      this.formInline.machineStatus = this.$route.query.machineStatus;
    }

    this.onSubmit();
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.machineInShopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        machineImei: this.formInline.machineImei,
        vendorid: this.formInline.vendorid,
        agentid: this.formInline.agentid,
        machineInShopid: this.formInline.machineInShopid,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };

      this.$axios(this.$urlMapping["查询离线"], {
        data: queryModel
      }).then(result => {
        console.log(result);
        this.tableData = result.data;
        // this.shopInfoEntityList = result.data
        //   .map(ele => ele.shopInfoEntity)
        //   .filter(ele => ele !== null);
        // this.vendorEntityList = result.data
        //   .map(ele => ele.vendorEntity)
        //   .filter(ele => ele !== null);
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
